import * as Yup from 'yup';

export const resetValidationSchema = Yup.object({
  password: Yup.string() 
      .required('Password is required') 
      .min(8, 'Password must be at least 8 characters long')     // 1. Check for at least one number    
      .matches(/\d/, 'Password must contain at least one number')     // 2. Check for at least one uppercase letter    
      .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')     // 3. Check for at least one lowercase letter    
      .matches(/[a-z]/, 'Password must contain at least one lowercase letter')     // 4. Check for at least one special character    
      .matches(/[!@#$%^&*(),.?":{}|<>_\-+=\[\]\\\/~`]/,  'Password must contain at least one special character'    ),
 

  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .required('Confirm Password is required'),
})
